export class ReminderLeadInput {
  leadId: string;
  reminderDate: Date;
  comments?: string;
}
